import { render, staticRenderFns } from "./InputfieldForm.vue?vue&type=template&id=63f2083a&"
import script from "./InputfieldForm.vue?vue&type=script&lang=js&"
export * from "./InputfieldForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports